import { useSelector } from 'react-redux';

import { useDeskId } from '@/hooks/useDeskId';
import { useIntegrations } from '@/hooks/useIntegrations';
import { selectIntegrationId } from '@/redux/session/selectors';
import { WebVoiceIntegration } from '@/shared/types/integration';

import IntegrationConfigWrapper from '../Components/Integration';
import Connection from './cards/Connection';
import AdvancedSettings from '../VoiceCommon/cards/AdvancedSettings';
import Configuration from '../VoiceCommon/cards/Configuration';
import NoiseSuppression from '../VoiceCommon/cards/NoiseSuppression';
import Preferences from '../VoiceCommon/cards/Preferences';
import Transcription from '../VoiceCommon/cards/Transcription';
import Voice from '../VoiceCommon/cards/Voice';
import VoiceIntegrationSkeleton from '../VoiceCommon/cards/VoiceIntegrationSkeleton';

const IntegrationWebVoice = () => {
  const integrationId = useSelector(selectIntegrationId);
  const deskId = useDeskId();
  const { integration, getStatus } = useIntegrations<WebVoiceIntegration>(deskId, integrationId);

  if (getStatus === 'pending' || !integration) {
    return <VoiceIntegrationSkeleton />;
  }

  return (
    <IntegrationConfigWrapper integration={integration} className="gap-12">
      <Connection integration={integration} />
      <Preferences>
        <NoiseSuppression />
      </Preferences>
      <Configuration />
      <AdvancedSettings>
        <Transcription />
        <Voice />
      </AdvancedSettings>
    </IntegrationConfigWrapper>
  );
};

export default IntegrationWebVoice;
